import React from "react";
import { Form } from "react-bootstrap";
import { components, default as ReactSelect } from "react-select";

const Option = (props: any) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{display:'none'}}
                // className="form-select2"
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

interface OptProps {
    value: string
    label: string
    imgUrl?: string
}
interface SingleSelectProps {
    options: OptProps[]
    label?: string
    errorText?: string
    filterText?: string
    selectedOptions: any
    setSelectedOptions: React.Dispatch<any>
    disabled?: boolean
    onChange?: () => void
    placeHolder?: string

}
const customStyles = {
    control: (provided: any, state: any) => ({
        ...provided,
        minHeight: '30px',
        height: '33px',
    }),

    valueContainer: (provided: any, state: any) => ({
        ...provided,
        height: '30px',
        padding: '0 6px',
        overflowY: 'hidden',
    }),

    input: (provided: any, state: any) => ({
        ...provided,
        margin: '2px',
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        height: '30px',
    }),
};

const SingleSelect: React.FC<SingleSelectProps> = (props: SingleSelectProps) => {
    const { options, label, errorText, selectedOptions, setSelectedOptions, disabled, onChange, placeHolder, filterText } = props;
    
    const handleChange = (selected: any) => {
        setSelectedOptions(selected)
        // if (filterText === 'Portfolio') {
        //     localStorage.removeItem('portfolioFilter')
        //     localStorage.setItem('portfolioFilter', JSON.stringify(selected));
        // }

        // if (filterText === 'Center') {
        //     localStorage.removeItem('centerFilter')
        //     localStorage.setItem('centerFilter', JSON.stringify(selected));
        // }
        onChange?.()
    }
    return (
        <>
            <Form.Group>
                {label ? (
                    <>
                        {' '}
                        <Form.Label className="label">{label}</Form.Label>
                    </>
                ) : null}
                <ReactSelect
                    options={options}  components={{ Option }}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    value={selectedOptions}
                    onChange={handleChange}
                    isDisabled={disabled}
                    placeholder={placeHolder}
                    styles={customStyles}
                    
                    classNames={{
                        control: (props) => {
                            return 'form-multi-select2 p-0'
                        },
                    }}
                />

                {errorText && <Form.Control.Feedback type="invalid" className="d-block">
                    {errorText}
                </Form.Control.Feedback>}
            </Form.Group>
        </>
    )
}

export default SingleSelect